export const DOCUMENTS = {
  CREATE_DOCUMENT: 'CREATE_DOCUMENT',
  DOWNLOAD_DOCUMENT: 'DOWNLOAD_DOCUMENT',
  DOWNLOAD_DOCUMENT_BY_ID: 'DOWNLOAD_DOCUMENT_BY_ID',
  DOWNLOAD_DOCUMENT_COMPANY_BY_ID: 'DOWNLOAD_DOCUMENT_COMPANY_BY_ID',
  REMOVE_DOCUMENT: 'REMOVE_DOCUMENT',
  REMOVE_DOCUMENT_COMPANY: 'REMOVE_DOCUMENT_COMPANY',
  REMOVE_DOCUMENTS: 'REMOVE_DOCUMENTS',

  GET_DOCUMENTS: 'GET_DOCUMENTS',
  GET_DOCUMENTS_SUCCESS: 'GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_FAIL: 'GET_DOCUMENTS_FAIL',

  GET_DRAWING: 'GET_DRAWING',
  GET_DRAWING_SUCCESS: 'GET_DRAWING_SUCCESS',
  GET_DRAWING_FAIL: 'GET_DRAWING_FAIL',

  GET_ESTIMATES: 'GET_ESTIMATES',
  GET_ESTIMATES_SUCCESS: 'GET_ESTIMATES_SUCCESS',
  GET_ESTIMATES_FAIL: 'GET_ESTIMATES_FAIL',

  GET_SINGLE_DOCUMENT: 'GET_SINGLE_DOCUMENT',
  GET_SINGLE_DOCUMENT_SUCCESS: 'GET_SINGLE_DOCUMENT_SUCCESS',
  GET_SINGLE_DOCUMENT_FAIL: 'GET_SINGLE_DOCUMENT_FAIL',

  RESET_ALL_DOCS: 'RESET_ALL_DOCS',
  RESET_SINGLE_DOC: 'RESET_SINGLE_DOC',

  REQUEST_APPROVAL: 'REQUEST_APPROVAL',
  UPDATE_DOCUMENT_STATUS: 'UPDATE_DOCUMENT_STATUS',
  APPROVE_DOCUMENT: 'APPROVE_DOCUMENT',
  REJECT_DOCUMENT: 'REJECT_DOCUMENT',

  SET_DOCUMENT_TAB: 'SET_DOCUMENT_TAB',
  ADD_DOCUMENTS: 'ADD_DOCUMENTS',
  ADD_DOCUMENTS_SUCCESS: 'ADD_DOCUMENTS_SUCCESS',
  ADD_DOCUMENTS_FAIL: 'ADD_DOCUMENTS_FAIL',
  ADD_ESTIMATES: 'ADD_ESTIMATES',
  ADD_DRAWING: 'ADD_DRAWING',
  ADD_DRAWING_SUCCESS: 'ADD_DRAWING_SUCCESS',
  ADD_DRAWING_FAIL: 'ADD_DRAWING_FAIL',
  SET_FILTER_QUERY: 'SET_FILTER_QUERY',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  RESET_ALL_FILTERS: 'RESET_ALL_FILTERS'
};
